<template>
  <div
    class="mb-4 grid gap-4 rounded-lais border border-lais-border-soft bg-lais-bg-soft p-4"
    aria-busy="true"
    aria-live="polite"
  >
    <div class="flex items-center justify-between gap-4">
      <div class="grid flex-1 gap-2">
        <span class="h-4 w-40 animate-pulse rounded bg-lais-bg-muted" />
        <span
          class="h-3 w-64 max-w-full animate-pulse rounded bg-lais-bg-muted"
        />
      </div>
      <span class="h-8 w-28 animate-pulse rounded-full bg-lais-bg-muted" />
    </div>
    <div class="grid gap-3 sm:grid-cols-3">
      <span class="h-16 animate-pulse rounded-lais bg-white" />
      <span class="h-16 animate-pulse rounded-lais bg-white" />
      <span class="h-16 animate-pulse rounded-lais bg-white" />
    </div>
  </div>
</template>
